import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import "./ComplianceModal.scss";
import Close from "../../images/close-light.svg";
import GreenCheck from "../../images/CheckIcon.svg";
import ComplianceModalTable from "../ComplianceModalTable/ComplianceModalTable";
import { getCustomerWithID } from "../../util/API/reporting";

function ComplianceModal({
  open,
  handleClose,
  selectedData,
  setSelectedData,
  fullSelectedData,
  setfullSelectedData,
  view,
}) {
  const [senderData, setSenderData] = useState();
  const [recipientData, setRecipientData] = useState();
  const [previousTransactions, setPreviousTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fullRecipientData, setfullRecipientData] = useState([]);
  const [fullSenderData, setFullSenderData] = useState([]);

  useEffect(() => {
    const getUserInfo = async () => {
      let senderDataResponse;
      let recipientDataResponse;

      if (selectedData) {
        senderDataResponse = await getCustomerWithID(fullSelectedData.userid);
        recipientDataResponse = await getCustomerWithID(
          fullSelectedData.r_userid
        );
        setfullRecipientData(recipientDataResponse.payload.body);
        setFullSenderData(senderDataResponse.payload.body);
        setLoading(false);
      }
    };
    getUserInfo();
  }, [selectedData]);

  const setData = (data, fullData) => {
    //This is for the onclick to scroll the modal to the top
    const modalElement = document.getElementsByClassName("centered-content")[0];

    if (modalElement) {
      modalElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      //Setting the data for the transaction to be shown
      setSelectedData(data);
      setfullSelectedData(fullData);

      let updatedTransactions = [...previousTransactions];

      const existingIndex = updatedTransactions.findIndex(
        (transaction) => transaction.id === fullData.id
      );

      if (existingIndex !== -1) {
        updatedTransactions.splice(existingIndex, 1);
      }

      updatedTransactions = [fullData, ...updatedTransactions];

      if (updatedTransactions.length > 7) {
        updatedTransactions.pop();
      }

      setPreviousTransactions(updatedTransactions);
    } else {
      console.error("Modal element not found");
    }
  };

  const resetPreviousTransactions = () => {
    setPreviousTransactions([]);
  };

  const handleClickPreviousUser = (data, fullData) => {
    const modalElement = document.getElementsByClassName("centered-content")[0];
    modalElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setSelectedData(data);
    setfullSelectedData(fullData);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="compliance-container-modal"
        style={{
          position: "fixed",
          zIndex: 9999,
          display: "flex",
        }}
      >
        <div className="centered-content">
          <div className="d-flex justify-content-between">
            {loading ? (
              <></>
            ) : (
              <div className="modal-title">
                Transaction Details for User:{" "}
                {view == "flipping"
                  ? fullSelectedData.sender_userid
                  : fullSelectedData.userid}{" "}
                - {selectedData.senderFirstName} {selectedData.senderLastname}
              </div>
            )}

            <img className="pointer" src={Close} onClick={handleClose} />
          </div>
          {selectedData ? (
            <div>
              {/* <div>
                AML Rule:{" "}
                {fullSelectedData.amruledesc
                  ? fullSelectedData.amruledesc
                  : "Flipping"}
              </div> */}

              <div className="d-flex compliance-modal-details-container">
                <div className="compliance-user-details">
                  <div className="transaction-user-info-container">
                    <div className="transcation-usertype">Sender</div>
                    {/* <img src={AnonUser} /> */}
                    {!loading ? (
                      <div className="transaction-user-detail-container">
                        <div className="transaction-user-detail">
                          <span>Name:</span> {selectedData.senderFirstName}{" "}
                          {selectedData.senderLastname}
                        </div>
                        <div className="transaction-user-detail">
                          <span> Email:</span>{" "}
                          {fullSenderData.Useremailaccount.emailAccount}
                        </div>
                        <div className="transaction-user-detail">
                          <span>Telephone No:</span>{" "}
                          {fullSenderData.User.contactPhoneNo}
                        </div>

                        <div className="transaction-user-detail">
                          <span>Date of Birth:</span> {selectedData.BirthDate}
                        </div>
                        <div className="transaction-user-detail">
                          <span>User ID: {fullSenderData.User.id}</span>
                        </div>
                        <div className="transaction-user-detail">
                          <span> Address:</span> {selectedData.senderAddress1}
                        </div>
                        <div className="transaction-user-detail">
                          <span>City:</span> {selectedData.senderCity}
                        </div>
                        <div className="transaction-user-detail">
                          <span>Country:</span> {selectedData.senderCountry}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="compliance-user-details">
                  <div className="transaction-user-info-container">
                    <div className="transcation-usertype">Recipient</div>
                    {!loading ? (
                      <div className="transaction-user-detail-container">
                        <div className="transaction-user-detail">
                          <span>Name:</span> {selectedData.receiverFirstName}{" "}
                          {selectedData.receiverLastName}
                        </div>
                        <div className="transaction-user-detail">
                          <span> Email:</span>{" "}
                          {fullRecipientData.Useremailaccount.emailAccount}
                        </div>
                        <div className="transaction-user-detail">
                          <span>Telephone No:</span>{" "}
                          {fullRecipientData.User.contactPhoneNo}
                        </div>
                        <div className="transaction-user-detail">
                          <span>Date of Birth:</span>
                          {fullRecipientData.User.dateofbirth}
                        </div>
                        <div className="transaction-user-detail">
                          <span>User ID:</span> {fullRecipientData.User.id}
                        </div>
                        <div className="transaction-user-detail">
                          <span> Address:</span>{" "}
                          {fullRecipientData.User.address1}
                        </div>
                        <div className="transaction-user-detail">
                          <span>City:</span> {fullRecipientData.User.cityname}
                        </div>
                        <div className="transaction-user-detail">
                          <span>Country:</span>{" "}
                          {fullRecipientData.User.countryid}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="compliance-detail-information transaction-user-info-container">
                  <div className="transaction-modal-header">
                    Transaction Details
                  </div>
                  <div className="transaction-modal-transaction-details">
                    <div className="transaction-user-detail-container">
                      <div className="transaction-user-detail">
                        <span>Transaction Date:</span> {selectedData.sendDate}
                      </div>
                      <div className="transaction-user-detail">
                        <span>Refrence No:</span> {selectedData.ReferenceNumber}
                      </div>
                      <div className="transaction-user-detail">
                        <span>Clerk Name:</span> {selectedData.senderAgentName}
                      </div>
                      <div className="transaction-user-detail">
                        <span>Amount:</span>{" "}
                        {selectedData.senderLocalCurrencyAmount}
                      </div>
                      <div className="transaction-user-detail">
                        <span>Consumer Fees:</span> 0
                      </div>
                      <div className="transaction-user-detail">
                        <span>Merchant Fees:</span> 0
                      </div>

                      <div className="transaction-user-detail">
                        <span>Total Amount:</span>{" "}
                        {selectedData.senderLocalCurrencyAmount}
                      </div>
                    </div>
                    <div className="transaction-modal-transaction-status">
                      <div className="d-flex">
                        <div className="transaction-status-text pr-3">
                          Transaction Status:{" "}
                          <span className="mr-3">Completed</span>
                        </div>
                        <img src={GreenCheck} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="compliance-modal-container mt-4">
                <div className="compliance-modal-table-container">
                  <ComplianceModalTable
                    setSelectedData={setData}
                    fullSelectedData={fullSelectedData}
                    setfullSelectedData={setfullSelectedData}
                    selectedData={selectedData}
                    resetPreviousTransactions={resetPreviousTransactions}
                    view={view}
                  />
                </div>
              </div>

              <div className="previous-transaction-container">
                <div className="last-selected-user ">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex previous-user-container">
                      {previousTransactions.map((user) => (
                        <div
                          className="previously-selected-user d-flex"
                          onClick={() =>
                            handleClickPreviousUser(
                              JSON.parse(
                                user.sourcedata.replace(/&quot;/g, '"')
                              ).record,
                              user
                            )
                          }
                        >
                          <div>
                            {
                              JSON.parse(
                                user.sourcedata.replace(/&quot;/g, '"')
                              ).record.ReferenceNumber
                            }
                          </div>
                        </div>
                      ))}
                    </div>

                    <div>Previously Viewed Transactions</div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}

          {/* <DetailedTransactionTabs selectedTransaction={selectedTransaction} /> */}
        </div>
      </Modal>
    </div>
  );
}

export default ComplianceModal;
